export default __webpack_public_path__ + "static/media/2.def751ca.webp";